import React, { useState } from "react";
import { CardHeader, Spinner } from "reactstrap";
import { FaQuestionCircle } from "react-icons/fa";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useSelector } from "react-redux";
import { useGetUserFollowingQuery } from "../../../../store/api/userManagementApi";

const FollowingUsers = () => {
    console.log("Rendering FollowingUsers");
    const userData = useSelector(state => state.userManagement.userData) || {};
    const user_id = userData?.user_id;
    const [currentPage, setCurrentPage] = useState(1);
    const sizePerPage = 100;

    const {
        data: followingResponse,
        isLoading,
        isFetching,
        error,
    } = useGetUserFollowingQuery(
        {
            userId: user_id,
            page: currentPage,
            limit: sizePerPage,
            connectionType: "following",
        },
        { skip: !user_id }
    );

    const followingUsers = followingResponse?.success ? followingResponse?.data || [] : [];
    const totalItems = followingResponse?.totalItems || followingResponse?.count || 0;
    const showLoading = isLoading || isFetching;
    const hasError = Boolean(error) || (followingResponse && followingResponse.success === false);

    const columns = [
        {
            dataField: "user",
            text: "",
            formatter: (cell, row) => (
                <div className="d-flex align-items-center">
                    <img
                        src={row.image}
                        alt="User"
                        className="rounded-circle"
                        width="50"
                        height="50"
                    />
                    <div className="d-flex flex-column pl-2">
                        <strong>{row.name}</strong>
                    </div>
                </div>
            ),
            headerStyle: { width: "100%" },
            align: "left",
            headerAlign: "center",
        },
    ];

    const rowStyle = () => ({
        borderBottom: "1.5px solid #ddd",
    });

    const paginationOptions = {
        page: currentPage,
        sizePerPage,
        totalSize: totalItems,
        pageStartIndex: 1,
        paginationSize: 5,
        withFirstAndLast: true,
        alwaysShowAllBtns: true,
        hideSizePerPage: true,
    };

    return (
        <>
            <CardHeader className="bg-transparent border-bottom mb-3">
                <h4 className="mb-0">Following Users</h4>
                <p className="text-muted small mb-0">
                    List of users the user is following
                </p>
            </CardHeader>
            {
                showLoading
                    ? (
                        <div className="text-center p-5">
                            <Spinner color="primary" />
                            <p className="mt-2 text-muted">Loading following users...</p>
                        </div>
                    )
                    : hasError
                        ? (
                            <div className="text-center p-4">
                                <FaQuestionCircle size={40} className="text-muted mb-3" />
                                <p className="mb-0">Failed to fetch following data</p>
                            </div>
                        )
                        : followingUsers?.length === 0
                            ? (<div className="text-center p-4">
                                <FaQuestionCircle size={40} className="text-muted mb-3" />
                                <p className="mb-0">No following users found</p>
                            </div>
                            ) : (
                                <div className="tableList">
                                    <div className="ui-table-responsive new-table px-3">
                                        <BootstrapTable
                                            id="following-users-table"
                                            keyField="id"
                                            data={followingUsers}
                                            columns={columns}
                                            hover
                                            bordered={false}
                                            rowStyle={rowStyle}
                                            remote
                                            onTableChange={(type, { page }) => {
                                                if (type === "pagination") {
                                                    setCurrentPage(page);
                                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                                }
                                            }}
                                            pagination={paginationFactory(paginationOptions)}
                                        />
                                    </div>
                                </div>
                            )
            }
        </>
    );
};

export default FollowingUsers;